// extracted by mini-css-extract-plugin
module.exports = {"wrap":"fj-z","heading":"gj-z","brandPromo":"hj-z"};